import React from 'react';
import ReviewAlbumManagement from './ReviewAlbumManagement';

export default function PMarkManagement(props) {
  return <ReviewAlbumManagement {...props} starred={true} />;
}
